import $ from "jquery";
import 'jquery-mousewheel';
import 'jscrollpane/style/jquery.jscrollpane.css';
import 'jscrollpane';

class Scroll {

	Init = () => {
		function updateScrollPane(sp) {
			if (sp.data('inited')) {
				sp.data('jsp').reinitialise();
			}
			else {
				sp.jScrollPane({maintainPosition: true, verticalGutter: 0, mouseWheelSpeed: 50, arrowButtonSpeed: 50});
				sp.data('inited', true);
			}
		}

		$('[data-scroll]').each(function() {
			var sp = $(this);
			updateScrollPane(sp);
			sp.bind('jsp-update', function(event) {
				updateScrollPane($(this));
			});
		});

		$(window).resize(function() {
			$('[data-scroll]').each(function() {
				updateScrollPane($(this));
			});
		});
	};

}

export default new Scroll;